import { useEffect } from "react";
import { FlexGrid, Button, Typography, useDialog, useThemeProvider, Card, Skeleton } from "@albo-ui/core";
import { RewardsReportProps, RewardsProps } from "./types";
import { useRewardsTable } from "./hooks/useRewardsTable";
import { useRewardsUpdate } from "./hooks/useRewardsUpdate";
import DataTable from "react-data-table-component";
import { customStyles2 } from "../../../util/TableStyles";
import { noDataComponent } from "../../../util/DataObject";
import { paginationComponentOptions } from "../../../util/i18n-es";
import { LocalActivity } from "@mui/icons-material";
import { Tab, Tabs, Box } from "@mui/material";
import ManageRewards from "../../modals/coupons-rewards";
import { useCouponDetail } from "./hooks/useCouponDetail";
import { FilterRewards } from "../../modals/coupons-rewards/FilterRewards";

export const CouponsReward = ({changeAlert, changeLoader, catalogs}: RewardsReportProps) => {
    const { theme } = useThemeProvider();
    const dialogProps = useDialog();
    const dialogFilter = useDialog();

    const { columns, data, loading: loadingTable, tabActive, tabs, title, row, action, changeTab, getData, setCatalog, onOpenDialogReward, onCloseDialogReward, DialogConfirm, filterReward } = useRewardsTable(changeAlert, dialogProps, dialogFilter);
    const { loading: loadingUpdate, manageReward } = useRewardsUpdate(changeAlert);

    const onManageReward = async (data: RewardsProps) => {
        dialogProps.onClose();
        manageReward(data, action, tabActive, getData);
    };
    const onCloseFilter = async () => {
        dialogFilter.onClose();
    };
    const onFilterReward = async () => {
        dialogFilter.openDialog();
    };
    useEffect(() => {
        changeLoader(loadingTable);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);
    useEffect(() => {
        changeLoader(loadingUpdate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate]);
    useEffect(() => {
        setCatalog(JSON.parse(JSON.stringify(catalogs)));
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Card fullWidth fullHeight padding={5} alignItems="stretch" flexDirection="column" justifyContent="space-between" style={{ borderColor: theme.colors.manatee, margin: 3 }}>
            <FlexGrid container fullWidth justify="space-between" style={{ display: "flex", marginBottom: 25 }}>
                <FlexGrid item container direction="column">
                    <Typography variant="h2" style={{display: "inline-flex", alignItems: "center", fontSize: "1.2rem"}}>
                        <LocalActivity sx={{ marginRight: 1 }} /> Gestor de Promociones
                    </Typography>
                    {tabs.length === 0 &&
                        <Typography variant="smallTitle" color="required">
                            Solicita permisos para continuar
                        </Typography>
                    }
                </FlexGrid>
                {tabs.length > 0 && (tabActive === "promotions" || tabActive === "configuration") && 
                    <FlexGrid item container spacing={2} style={{width: "30%", justifyContent: 'end'}}>
                        <Button onClick={onOpenDialogReward.bind(this, "Crear", null)} buttonType="secondary" size="normal">
                            Crear {tabActive === "promotions" ? "Promoción" : "Configuración"}
                        </Button>
                        <Button buttonType='primary' size='normal' onClick={onFilterReward}>Filtrar</Button>
                    </FlexGrid>
                }
            </FlexGrid>

            {loadingTable ? 
                <Skeleton width="100%" height="100px" style={{ marginTop: 20 }}/>
                : 
                <>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }} mb={2}>
                        <Tabs value={tabActive} indicatorColor="secondary" textColor="secondary">
                            {tabs.map((item, index) => {
                                return (
                                    <Tab
                                        key={index} label={item.title} value={item.name} onClick={changeTab.bind(this, item.name)}
                                        sx={{textTransform: "none", fontWeight: 700, fontFamily: "Muli,sans-serif", fontSize: 14,}}
                                    />
                                );
                            })}
                        </Tabs>
                    </Box>
                    <FlexGrid container spacing={2} style={{ margin: "25px 0" }}>
                        {loadingTable ? 
                            <Skeleton width="100%" height="100px" />
                            : 
                            <DataTable
                                columns={columns}
                                data={data}
                                customStyles={customStyles2}
                                noDataComponent={noDataComponent}
                                progressPending={loadingTable}
                                paginationComponentOptions={paginationComponentOptions}
                                expandableRows={tabActive === "configuration" || tabActive === "history_config" ? true : false}
                                expandOnRowClicked={false}
                                expandableRowsComponent={useCouponDetail.bind(this)}
                            />
                        }
                    </FlexGrid>
                </>
            }
            <ManageRewards
                open={dialogProps.open}
                title={title}
                data={row}
                tabActive={tabActive}
                onConfirm={onManageReward.bind(this)}
                onClose={onCloseDialogReward}
                changeAlert={changeAlert}
                catalog={catalogs}
            />
            <DialogConfirm/>
            <FilterRewards
                open={dialogFilter.open}
                title={"Filtrar"}
                onConfirm={filterReward.bind(this)}
                onClose={onCloseFilter}
                catalog={catalogs}
                tabActive={tabActive}
            />
        </Card>
    );
};
